import React, { useState, useEffect } from 'react'
import teacher from "../imgs/teacher.png"
import { Button, Form, Row, Col } from "react-bootstrap"
import Fade from 'react-reveal/Fade';
import InputField from '../components/InputField';
import { useStateMachine } from "little-state-machine";
import { useForm } from "react-hook-form";
import updateAction from "../updateAction";
import * as yup from "yup";
import { Navigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup"
import { Helmet } from 'react-helmet'
import { useNavigate } from "react-router-dom";
var SBool = "false";
const Sstep3 = (props) => {
    let navigate = useNavigate();
    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: "all"
        , resolver: yupResolver(schema)
    });
    const { state, actions } = useStateMachine({ updateAction });
    const [Mstat, setMstat] = useState();
    // const [SBool, setSBool] = useState();

    const onSubmit = data => {
        console.log(data);
        actions.updateAction(data);
        navigate("/Sstep4", { replace: true });
    };

    const [go, setgo] = useState(false);

    useEffect(() => {
        if (!state.firstname) {
            setgo(true);
        }
    });
    return (
        <>
            <Helmet>
                <title>Registration</title>
            </Helmet>
            {go && (
                <Navigate to='/Sstep1' />
            )}
            <div className="bg"></div>
            <div className="bg bg2"></div>
            <div className="bg bg3"></div>
            {/* <div className="content"> */}

            <div className="container1">

                <div className="wrapper1">
                    <ul className="steps">
                        <li className="is-active">Step 4 of 6</li>
                    </ul>
                    <form className="form-wrapper1" onSubmit={handleSubmit(onSubmit)}>

                        <fieldset className="section is-active">
                            <Fade>
                                <>
                                    <h3>Welcome, {state.firstname}</h3>
                                    <p>Tell us a little more about yourself</p>
                                    {/* {Mstat != "Single" && (
                                        <InputField register={register} errorinfo={errors} placeholder="John Doe" label="Spouse's full name" name="SpouseName" />
                                    )} */}

                                    <InputField register={register} errorinfo={errors} label="how many children do you have?" type="number" name="childnNum" />

                                    <InputField register={register} errorinfo={errors} placeholder="#32 hillview lane" label="Postal Address" name="address" />


                                    <InputField register={register} errorinfo={errors} label="Qualifications" placeholder="(Example: list the CXC/CSEC subjects you passed and their grades,trade,skills,certifications,etc...)" name="Qualifications" as="textarea" />

                                    <InputField register={register} errorinfo={errors} placeholder="John Doe" label="Pastor's name" name="PastorName" />

                                    <InputField register={register} errorinfo={errors} type="month" label="When did you become a member of your current church?" name="churchtime" />


                                    <Row>
                                        <Col>
                                            <InputField register={register} errorinfo={errors} type="date" label="Date you were born of the Spirit" name="DOBSpirit" />
                                        </Col>
                                        <Col>
                                            <InputField register={register} errorinfo={errors} type="date" label="Date you were baptized in water" name="bapDate" />
                                        </Col>
                                    </Row>
                                    <InputField register={register} errorinfo={errors} label="Ministerial Position" placeholder="Worship leader" name="Ministry" />
                                    <InputField register={register} errorinfo={errors} as="textarea" label="Ministry Involvement" placeholder="I help in sunday school and play guitar on the worship team etc" name="MinistryInvolvement" />
                                    <InputField register={register} errorinfo={errors} label="Born again experience (Testimony)" as="textarea" placeholder="I accepted Jesus because..." name="Testimony" />

                                    <Button type="submit">next</Button>
                                </>
                            </Fade>
                        </fieldset>

                    </form>
                </div>
            </div>


            {/* </div> */}
        </>
    )
}
const schema = yup.object().shape({
    // SpouseName:yup.string().when(SBool, {
    //     is: "true",
    //     SpouseName:yup.string().required("enter your spouse's name")
    //   }),
    childnNum: yup.string().trim().required("Enter how many children you have this could be 0"),
    address: yup.string().trim().required("enter your address"),
    Qualifications: yup.string().trim().required("Enter your qualifications").test("check for subjects","Please list the CXC/CSEC subjects you passed and the grades you obtained",(value) => {
        if (value.trim().toLowerCase() == "cxc" || value.trim().toLowerCase() == "csec")
            return false;
        else
            return true;
    }),
    PastorName: yup.string().trim().required("enter your pastor's name"),
    churchtime: yup.string().trim().required("enter the year you joined your church"),
    DOBSpirit: yup.date().required("enter the date you were born of the spirit of God"),
    bapDate: yup.date().required("Enter the date you were baptized in water"),
    Ministry: yup.string().trim().required("Enter your ministry"),
    MinistryInvolvement: yup.string().trim().required("Enter your ministry involvement"),
    Testimony: yup.string().trim().required("Enter your testimony about how you accepted Jesus Christ")
})


export default Sstep3
